import { EditorInformation, ObjectEditorType } from '@decisions/server/DecisionsFramework/Design/Properties';
import { ActionDisplayType } from '@decisions/server/DecisionsFramework/ServiceLayer/Actions';
import classNames from 'classnames';
import React from 'react';
import './EditorLink.less';
import { EditorLinkModel } from './EditorLinks';
import { ActionLinkInfo, ActionLinkModel } from './PropertyGrid';

interface IEditorLinkProps extends React.HTMLProps<{}> {
  link: EditorLinkModel | ActionLinkModel;
}

const getClassName = (isPrimary?: boolean) =>
  classNames('dpc-editor-link', {
    'dp-button-outline full-size': isPrimary,
  });

/**
 * Editor link for quick actions when editing a step, etc.
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function EditorLink({ link }: IEditorLinkProps) {
  const name = link.info.Name;
  const isPrimary = isPrimaryLink(link);

  return (
    // TODO - should these be configuration on ActionLinks, instead of their own special button?
    <button title={name} onClick={link.action} className={getClassName(isPrimary)}>
      {name}
    </button>
  );
}

function isPrimaryLink(link: EditorLinkModel | ActionLinkModel): boolean {
  if (isEditorLink(link.info)) {
    return link.info.EditorType === ObjectEditorType.AsPrimaryAction;
  } else {
    return link.info.DisplayType === ActionDisplayType.Primary;
  }
}

function isEditorLink(info: EditorInformation | ActionLinkInfo): info is EditorInformation {
  return (info as EditorInformation).EditorType !== undefined;
}
